import {
  EmbedItemType,
  MessageBoxItemType,
  PdfViewerRedirect,
} from '../../PdfViewer/index.types';
import { adaptOneToOnePreviewDocument } from '../index.types';
import V2ViewerShell from '../V2ViewerShell';

interface Props {
  file?: Omit<PdfViewerRedirect, 'isDownloadEnabled'>;
  messageBoxItems?: MessageBoxItemType[];
  embedItems?: EmbedItemType[];
  translateKoToEn: (item: string) => string;
}

/** 1:1 공유 PDF의 V2 관리자 미리보기 진입점(수신자 화면과 동일 UI) */
const V2OneToOnePreview = ({
  file,
  messageBoxItems,
  embedItems,
  translateKoToEn,
}: Props) => {
  if (!file) {
    return null;
  }

  return (
    <V2ViewerShell
      document={adaptOneToOnePreviewDocument(file)}
      isBulk={false}
      isPreview
      messageBoxItems={messageBoxItems}
      embedItems={embedItems}
      translateKoToEn={translateKoToEn}
    />
  );
};

export default V2OneToOnePreview;
